/**
 * HDM Custom Product Constants.
 * This file re-exports all constants from the core product constants file
 * and allows for overriding or adding new constants.
 */

// Re-export all constants from the core file.
export * from '@/core/data/constants/product';

// Define and export any custom or overridden values here.
export const ASSOCIATION_TYPES = {
	compare: 'Comparar',
};
